import {
  BaseConfigurationModal,
  BaseConfigurationRow,
} from "./BaseConfiguration";
import { OAuthModal, OAuthRow } from "./OAuth";

const BASE_CONFIGURATION = "BASE_CONFIGURATION";
const OAUTH = "OAUTH";

const Rows = {
  [BASE_CONFIGURATION]: BaseConfigurationRow,
  [OAUTH]: OAuthRow,
};

const Modals = {
  [BASE_CONFIGURATION]: BaseConfigurationModal,
  [OAUTH]: OAuthModal,
};

const RowOrder = [BASE_CONFIGURATION, OAUTH];

const config = {
  Rows,
  RowOrder,
  Modals,
};

export default config;
